export default __webpack_public_path__ + "static/park_map_roads-5fa126df6a05884d0b55e81a60060105.svg";